import { Component } from "@angular/core";
import { SopoDialogRef } from "src/app/sopo-popup/interfaces/dialog";


@Component({
    selector: 'app-abstract-club-join-popup',
    templateUrl: './abstract-club-join-popup.component.html',
    styleUrls: ['./abstract-club-join-popup.component.scss'],
    standalone: false
})
export class AbstractClubJoinPopup {
    constructor(
        private sopoDialogRef: SopoDialogRef,
    ) { }

    navigateToLobby() {
        this.sopoDialogRef.close(true);
    }
}